import { render, staticRenderFns } from "./rightsComment.vue?vue&type=template&id=9775a96e&scoped=true"
import script from "./rightsComment.vue?vue&type=script&lang=js"
export * from "./rightsComment.vue?vue&type=script&lang=js"
import style0 from "./rightsComment.vue?vue&type=style&index=0&id=9775a96e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9775a96e",
  null
  
)

export default component.exports